import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    crm_plugin?: {
      id: string;
      hash: string;
      locale: string;
      setMeta: (p: any) => void;
      params?: any[];
    };
    crmPlugin?: any; // cola del plugin
  }
}

const KommoScript = () => {
  const location = useLocation();

  useEffect(() => {
    const excludePaths = ["/formulariorcv", "/formulariosalud"]; // rutas sin botón/chat
    const currentPath = location.pathname;

    const SCRIPT_ID = "crm_plugin_script";
    const SRC = "https://gso.kommo.com/js/button.js";

    const removeNodes = (selector: string) => {
      document.querySelectorAll(selector).forEach((el) => el.remove());
    };

    const cleanupKommo = () => {
      // script
      const existing = document.getElementById(SCRIPT_ID);
      if (existing) existing.remove();
      removeNodes('script[src*="gso.kommo.com/js/button.js"]');

      // UI inyectada (iframes/divs)
      removeNodes('iframe[src*="kommo"]');
      removeNodes('iframe[src*="gso.kommo.com"]');
      removeNodes('[id^="crm_plugin"]:not(script)');

      // globals
      try {
        delete window.crm_plugin;
      } catch {}
      try {
        delete window.crmPlugin;
      } catch {}
    };

    const shouldExclude = excludePaths.includes(currentPath);

    if (shouldExclude) {
      cleanupKommo();
      return;
    }

    // Si ya está cargado, no lo dupliques
    if (document.getElementById(SCRIPT_ID)) return;

    // ✅ NUEVO plugin (el que me pasaste)
    window.crm_plugin = {
      id: "1068743",
      hash: "b49eea644f0c00044a067559d2ee7260aa0dc14b9f7b1d7f5e3a038313047fe7",
      locale: "es",
      setMeta: function (p: any) {
        this.params = (this.params || []).concat([p]);
      },
    };

    window.crmPlugin =
      window.crmPlugin ||
      function () {
        (window.crmPlugin.q = window.crmPlugin.q || []).push(arguments);
      };

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = SRC;

    document.head.appendChild(script);

    // No hacemos cleanup en un return() general porque controlamos por rutas
  }, [location.pathname]);

  return null;
};

export default KommoScript;


